// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3eMQd","icon":"style_icon__1-R9h"};